import { HeadlessIcon, HeadlessIconProps } from '@cellula/react';
import loadedIllustrationSet from './illustration_set.json';
import { dangerouslyInjectHTML } from '@visiba/react-std';

interface IllustrationDictionary {
	fileExcel: string;
	filePdf: string;
	fileWord: string;
	fileImage: string;
	fileOtherFormat: string;
	attachedForm: string;
	error: string;
	closed: string;
	messageSent: string;
}

type IllustrationMap = {
	[key in keyof IllustrationDictionary]: {
		innerHTML: string;
		viewBox: string;
	};
};

export type IllustrationType = keyof IllustrationDictionary;

const illustrationMap = loadedIllustrationSet as unknown as IllustrationMap;

interface IllustrationProps extends Omit<HeadlessIconProps, 'viewBox'> {
	/**
	 * The icon to use.
	 */
	type: IllustrationType;
}

export function Illustration({ type, ...rest }: IllustrationProps): JSX.Element {
	return (
		<HeadlessIcon
			viewBox={illustrationMap[type]?.viewBox}
			dangerouslySetInnerHTML={dangerouslyInjectHTML(illustrationMap[type]?.innerHTML)}
			{...rest}
		/>
	);
}
